// extracted by mini-css-extract-plugin
export default {"actions":"CardActions_actions__nEKKH"};